/* Dibuja el catálogo de us.ricoseller.net dentro de ricoseller.net, con la
   misma armazón que una colección de Dawn: columna de filtros, barra de orden
   y la misma grilla de tarjetas.

   POR QUE DEL LADO DEL NAVEGADOR y no en Liquid: así estas tarjetas no quedan
   en el HTML de ricoseller.net. Si estuvieran, Google vería cientos de
   productos repetidos en dos dominios y los haría competir entre sí. Como
   tarjeta pintada por JS, el cliente las ve y el buscador sigue mandando a la
   ficha única, que vive en us.ricoseller.net.

   POR ESO MISMO los filtros también son de acá: estos productos no están en
   esta tienda, así que Shopify no puede filtrarlos del lado del servidor como
   hace en /collections/calzado.

   Los nombres de los <input> son los mismos que usa Dawn a propósito: así les
   cae encima el CSS de filtros-nike.css y los talles salen en grilla de
   fichas, igual que en básquet. El guión que mezcla tarjetas en las
   colecciones (catalogo-usa-grilla.js) no corre acá: busca #product-grid y
   esta grilla no lo tiene.

   Los datos salen de assets/catalogo-usa.json, que regenera una vez por día
   ~/ricoseller-catalogo-usa/sincronizar.py. */
(function () {
  var bloques = document.querySelectorAll("[data-catalogo-usa]");
  if (!bloques.length) return;

  var P_MARCA = "filter.p.m.custom.marca";
  var P_TALLE = "filter.v.option.talla del calzado";

  function pesos(n) {
    return "$" + Number(n).toLocaleString("es-AR");
  }

  function comoNumero(v) {
    var n = parseFloat(v);
    return isNaN(n) ? Infinity : n;
  }

  /* Lo que está marcado hoy, leído de la URL. */
  function seleccion() {
    var p = new URLSearchParams(location.search);
    var out = {};
    out[P_MARCA] = p.getAll(P_MARCA);
    out[P_TALLE] = p.getAll(P_TALLE);
    out.orden = p.get("orden") || "destacados";
    return out;
  }

  function aplicar(lista, sel) {
    return lista.filter(function (x) {
      if (sel[P_MARCA].length && sel[P_MARCA].indexOf(x.m) === -1) return false;
      if (sel[P_TALLE].length && !sel[P_TALLE].some(function (t) {
        return (x.z || []).indexOf(t) > -1;
      })) return false;
      return true;
    });
  }

  function ordenar(lista, orden) {
    var c = lista.slice();
    if (orden === "precio-asc") c.sort(function (a, b) { return a.p - b.p; });
    else if (orden === "precio-desc") c.sort(function (a, b) { return b.p - a.p; });
    else if (orden === "az") c.sort(function (a, b) { return a.t.localeCompare(b.t, "es"); });
    else if (orden === "za") c.sort(function (a, b) { return b.t.localeCompare(a.t, "es"); });
    return c;
  }

  function tarjeta(p, destino) {
    var li = document.createElement("li");
    li.className = "grid__item catalogo-usa__item" + (p.s ? "" : " catalogo-usa__item--agotado");
    var url = destino + p.h;
    var img = p.i.indexOf("?") > -1 ? p.i + "&width=533" : p.i + "?width=533";
    li.innerHTML =
      '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
        '<div class="card card--standard card--media" style="--ratio-percent:100.0%;">' +
          '<div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent:100.0%;">' +
            '<span class="label-stock-usa">Stock 🇺🇸</span>' +
            '<div class="card__media"><div class="media media--transparent">' +
              '<img src="' + img + '" alt="" loading="lazy" width="533" height="533">' +
            "</div></div>" +
          "</div>" +
          '<div class="card__content"><div class="card__information">' +
            '<h3 class="card__heading h5"><a class="full-unstyled-link" href="' + url +
              '" rel="noopener">' + p.t + "</a></h3>" +
            '<p class="producto-categoria">Calzado de básquet</p>' +
            '<div class="card-information"><div class="price"><div class="price__container">' +
              '<div class="price__regular"><span class="price-item price-item--regular">' +
                (p.s ? pesos(p.p) : '<span class="catalogo-usa__agotado">Agotado</span>') +
              "</span></div></div></div></div>" +
          "</div></div>" +
        "</div>" +
      "</div>";
    return li;
  }

  var CAJA = '<svg width="16px" height="16px" viewBox="0 0 16 16">' +
    '<rect width="16" height="16" fill="none" stroke="currentColor"/></svg>';
  var TILDE = '<div class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" ' +
    'class="icon icon-checkmark" viewBox="0 0 12 9"><path fill="currentColor" fill-rule="evenodd" ' +
    'd="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 ' +
    '.724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z" clip-rule="evenodd"/></svg></div>';
  var CARET = '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" ' +
    'fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 ' +
    '4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';

  /* Un grupo de filtros, con la misma pinta que los de una colección: los de
     marca con el logo (swatch) y los de talle en texto. */
  function grupo(titulo, campo, opciones, marcadas, logos) {
    var det = document.createElement("details");
    det.className = "facets__disclosure-vertical js-filter";
    det.setAttribute("open", "");

    var cuantas = marcadas.length
      ? '<span class="facets__selected"> (' + marcadas.length + ")</span>"
      : '<span class="facets__selected hidden"></span>';

    var items = opciones.map(function (o, i) {
      var id = "CatalogoUsa-" + campo.replace(/[^a-z]/gi, "") + "-" + i;
      var puesta = marcadas.indexOf(o.valor) > -1 ? " checked" : "";
      var entrada = '<input type="checkbox" name="' + campo + '" value="' +
        o.valor.replace(/"/g, "&quot;") + '" id="' + id + '"' + puesta;
      var texto = '<span class="facet-checkbox__text" aria-hidden="true">' +
        '<span class="facet-checkbox__text-label">' + o.etiqueta + "</span></span>";

      if (logos && logos[o.valor]) {
        var fondo = logos[o.valor] +
          (logos[o.valor].indexOf("?") > -1 ? "&" : "?") + "width=50";
        return '<li class="list-menu__item facets__item">' +
          '<div class="facets__label facet-checkbox">' +
            '<div class="swatch-input-wrapper">' +
              entrada + ' class="swatch-input__input">' +
              '<label for="' + id + '" class="swatch-input__label">' +
                '<span class="swatch" style="--swatch--background: url(' + fondo +
                '); --swatch-focal-point: 50.0% 50.0%;"></span></label>' +
            "</div>" + texto +
          "</div></li>";
      }
      return '<li class="list-menu__item facets__item">' +
        '<label for="' + id + '" class="facets__label facet-checkbox">' +
          entrada + ">" + CAJA + TILDE + texto +
        "</label></li>";
    }).join("");

    det.innerHTML =
      '<summary class="facets__summary caption-large focus-offset"><div>' +
        '<span class="facets__summary-label">' + titulo + cuantas + "</span>" + CARET +
      "</div></summary>" +
      '<div class="parent-display facets__display-vertical">' +
        '<fieldset class="facets-wrap parent-wrap facets-wrap-vertical">' +
          '<legend class="visually-hidden">' + titulo + "</legend>" +
          '<ul class="facets-layout facets-layout-list ' +
            (logos ? "facets-layout-list--swatch" : "facets-layout-list--text") +
            ' facets__list--vertical list-unstyled" role="list">' + items + "</ul>" +
        "</fieldset>" +
      "</div>";
    return det;
  }

  bloques.forEach(function (bloque) {
    var url = bloque.getAttribute("data-catalogo-usa");
    var filtro = bloque.getAttribute("data-coleccion") || "";
    var tope = parseInt(bloque.getAttribute("data-tope") || "0", 10);
    var grid = bloque.querySelector("[data-catalogo-usa-grid]");
    var estado = bloque.querySelector(".catalogo-usa__estado");
    var vacio = bloque.querySelector(".catalogo-usa__vacio");
    var cajaFacetas = bloque.querySelector("[data-catalogo-usa-facetas]");
    /* El conteo va pegado al título de la página, como en una colección
       ("Calzado de Performance (292)"), no en la barra de orden. */
    var titulo = document.querySelector("h1.main-page-title, h1.collection-hero__title");
    var conteo = null;
    if (titulo) {
      conteo = titulo.querySelector(".collection-hero__conteo");
      if (!conteo) {
        conteo = document.createElement("span");
        conteo.className = "collection-hero__conteo";
        titulo.appendChild(conteo);
      }
    }
    var selOrden = bloque.querySelector("[data-catalogo-usa-orden]");
    var limpiar = bloque.querySelector("[data-catalogo-usa-limpiar]");
    var abrir = bloque.querySelector("[data-catalogo-usa-abrir]");
    if (!grid) return;

    var datos = null;
    var base = [];

    /* Cambia la URL sin recargar: así el filtro se puede compartir y el botón
       de atrás del navegador deshace lo último, como en una colección. */
    function guardar(sel) {
      var p = new URLSearchParams();
      sel[P_MARCA].forEach(function (v) { p.append(P_MARCA, v); });
      sel[P_TALLE].forEach(function (v) { p.append(P_TALLE, v); });
      if (sel.orden && sel.orden !== "destacados") p.set("orden", sel.orden);
      /* toString() escribe los espacios como "+". Los dejamos como %20: las
         dos formas son válidas, pero con %20 la URL se lee igual en todos
         lados (incluido el nombre del filtro de talles, que lleva espacios). */
      var q = p.toString().replace(/\+/g, "%20");
      history.replaceState(null, "", location.pathname + (q ? "?" + q : ""));
    }

    function pintar() {
      var sel = seleccion();
      var lista = ordenar(aplicar(base, sel), sel.orden);
      if (tope > 0) lista = lista.slice(0, tope);

      grid.innerHTML = "";
      var frag = document.createDocumentFragment();
      lista.forEach(function (p) { frag.appendChild(tarjeta(p, datos.destino)); });
      grid.appendChild(frag);

      if (vacio) vacio.hidden = lista.length > 0;
      if (conteo) conteo.textContent = "(" + lista.length + ")";
      if (limpiar) {
        limpiar.hidden = !(sel[P_MARCA].length || sel[P_TALLE].length);
      }
      if (selOrden) selOrden.value = sel.orden;
      facetas(sel);
    }

    function facetas(sel) {
      if (!cajaFacetas) return;
      var marcas = {}, talles = {};
      base.forEach(function (p) {
        if (p.m) marcas[p.m] = true;
        (p.z || []).forEach(function (t) { talles[t] = true; });
      });

      cajaFacetas.innerHTML = "";
      var nm = Object.keys(marcas).sort(function (a, b) { return a.localeCompare(b, "es"); });
      if (nm.length > 1) {
        cajaFacetas.appendChild(grupo("Marcas", P_MARCA,
          nm.map(function (v) { return { valor: v, etiqueta: v }; }),
          sel[P_MARCA], datos.logos || {}));
      }
      var nt = Object.keys(talles).sort(function (a, b) { return comoNumero(a) - comoNumero(b); });
      if (nt.length) {
        cajaFacetas.appendChild(grupo("Talle", P_TALLE,
          nt.map(function (v) { return { valor: v, etiqueta: v }; }),
          sel[P_TALLE], null));
      }
    }

    cajaFacetas && cajaFacetas.addEventListener("change", function (e) {
      var i = e.target;
      if (!i || i.type !== "checkbox") return;
      var sel = seleccion();
      var campo = i.name;
      var ya = sel[campo].indexOf(i.value);
      if (i.checked && ya === -1) sel[campo].push(i.value);
      if (!i.checked && ya > -1) sel[campo].splice(ya, 1);
      guardar(sel);
      pintar();
    });

    selOrden && selOrden.addEventListener("change", function () {
      var sel = seleccion();
      sel.orden = selOrden.value;
      guardar(sel);
      pintar();
    });

    limpiar && limpiar.addEventListener("click", function (e) {
      e.preventDefault();
      history.replaceState(null, "", location.pathname);
      pintar();
    });

    /* En mobile la columna de filtros y la barra de orden están ocultas
       (small-hide, como en Dawn); el botón las muestra a las dos. */
    abrir && abrir.addEventListener("click", function () {
      bloque.classList.toggle("catalogo-usa--filtros-abiertos");
    });

    window.addEventListener("popstate", pintar);

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        datos = d;
        base = (d.productos || []).filter(function (p) {
          return !filtro || (p.c || []).indexOf(filtro) > -1;
        });
        if (estado) estado.remove();
        if (!base.length) { bloque.hidden = true; return; }
        pintar();
      })
      .catch(function () {
        /* Si el archivo no está o falla la red, el bloque se va entero:
           mejor que dejar un encabezado colgado sobre un hueco vacío. */
        bloque.hidden = true;
      });
  });
})();
